export class ResourceKey {
  resourceType: string;
  subscriptionId: string;
  subscriptionType: string;
}
